import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TemaModule } from './tema.module';
import { UsuarioConfiguracaoComponent } from './usuario-configuracao/usuario-configuracao.component';

@NgModule({
    declarations: [UsuarioConfiguracaoComponent],
    imports: [
        CommonModule,
        MatCardModule,
        MatIconModule,
        TemaModule,
        RouterModule.forChild([{ path: '', component: UsuarioConfiguracaoComponent }])
    ]
})
export class UsuarioConfiguracaoModule { }
